import APIAgencies from '@/api/modules/agencies';
import Cookies from 'js-cookie';

const initialState = {
  canManageAgencies: false,
  permissionVersion: 0,
  agencies: [],
  agenciesMeta: {},
  managers: [],
  filterManagers: [],
  managerVersion: 0,
};

export default {
  namespaced: true,
  state: initialState,
  mutations: {
    RESET_PERMISSIONS(state) { state.permissionVersion++; state.canManageAgencies = false; },
    SET_DATA(state, { type, data }) {
      state[type] = data;
    },
  },
  actions: {
    async refreshPermissions({ commit, state }) {
      const version = state.permissionVersion + 1;
      commit('SET_DATA', { type: 'permissionVersion', data: version });
      commit('SET_DATA', { type: 'canManageAgencies', data: false });
      // A 401 may refresh adminToken while the API retries the permission request.
      // Recheck with the current token instead of leaving a permitted user read-only.
      for (let attempt = 0; attempt < 2; attempt++) {
        const token = Cookies.get('adminToken');
        if (!token || version !== state.permissionVersion) return;
        try {
          const allowed = await APIAgencies.getPermissions();
          if (version !== state.permissionVersion) return;
          if (token === Cookies.get('adminToken')) {
            commit('SET_DATA', { type: 'canManageAgencies', data: allowed });
            return;
          }
        } catch (e) {
          if (version !== state.permissionVersion || token === Cookies.get('adminToken')) return;
        }
      }
    },
    getAgencies({ commit }, params) {
      return APIAgencies.getAgencies(params).then((response) => {
        if (response && response.data) {
          commit('SET_DATA', { type: 'agencies', data: response.data.agencies || [] });
          commit('SET_DATA', { type: 'agenciesMeta', data: response.data.meta || {} });
        }
      });
    },
    async getManagers({ commit, state }) {
      const version = state.managerVersion + 1;
      const token = Cookies.get('adminToken');
      commit('SET_DATA', { type: 'managerVersion', data: version });
      commit('SET_DATA', { type: 'filterManagers', data: [] });
      const response = await APIAgencies.getManagers();
      if (version !== state.managerVersion || token !== Cookies.get('adminToken')) return;
      commit('SET_DATA', { type: 'managers', data: response?.data?.managers || [] });
      // Unknown role evidence cannot fall back to the broader historical/assignment directory.
      commit('SET_DATA', { type: 'filterManagers', data: response?.data?.filter_managers || [] });
    },
    createAgency(_, data) {
      return APIAgencies.createAgency(data);
    },
    getPresentationUrls(_, agencyId) {
      return APIAgencies.getPresentationUrls(agencyId).then((response) => response?.data?.urls || []);
    },
    uploadPresentations(_, { agencyId, files }) {
      return APIAgencies.uploadPresentations(agencyId, files).then((response) => response?.data?.urls || []);
    },
    removePresentation(_, { agencyId, url }) {
      return APIAgencies.removePresentation(agencyId, url).then((response) => response?.data?.urls || []);
    },
  },
};
